// extracted by mini-css-extract-plugin
module.exports = {"selectWrap":"range-select_selectWrap_2n0QQ","container":"range-select_container_TJGbN"};